import { useQuery } from '@tanstack/react-query';
import { queries } from 'src/config/queries';
function mapDrippingConfig(drippings) {
    return drippings.map((dripping) => {
        let liberation = null;
        if (dripping.releaseDate) {
            liberation = { type: 'BY_DATE', liberationDate: dripping.releaseDate };
        }
        else if (dripping.releaseDays === 0 || dripping.releaseDays) {
            liberation = { type: 'BY_DAYS', liberationDays: dripping.releaseDays };
        }
        else if (dripping.pageId) {
            liberation = { type: 'BY_QUIZ', pageId: dripping.pageId };
        }
        const expiration = dripping.expirationDays === 0 || dripping.expirationDays
            ? { type: 'BY_DAYS', durationDays: dripping.expirationDays }
            : null;
        return {
            liberation,
            expiration,
            classes: dripping.classes.map(({ hashId }) => hashId),
            ...(dripping.id && { id: dripping.id })
        };
    });
}
function mapDrippingUpdateConfig(currentDrippings, newDrippings) {
    const currentIds = currentDrippings.map((drip) => drip.id);
    const newIds = newDrippings.map((drip) => drip.id);
    const deleted = currentIds.filter((id) => !newIds.includes(id));
    const saved = mapDrippingConfig(newDrippings);
    return { deleted, saved };
}
export function useContentPayload(isUpdate, pageId) {
    const contentRequest = useQuery({
        ...queries.content.byId(pageId),
        enabled: isUpdate && Boolean(pageId)
    });
    function mapContentFormValuesToPayload(moduleId, values) {
        return {
            page: {
                name: values.name,
                content: values.content,
                ...(isUpdate
                    ? {
                        updatedDrippingConfigs: mapDrippingUpdateConfig(contentRequest.data?.page.drippingConfigs ?? [], values.drippings)
                    }
                    : { drippingConfigs: mapDrippingConfig(values.drippings) }),
                moduleId
            },
            backgroundImageId: values.cover?.id ?? null,
            complementaryReadings: values.complementaryReadings,
            tags: values.tags,
            attachmentIdList: values.attachments?.map((attachment) => attachment.id) ?? [],
            mediaIdList: values.medias?.map((media) => media.id) ?? []
        };
    }
    return { mapContentFormValuesToPayload, contentRequest };
}
